import { z } from 'zod';

const TicketCategorySchema = z.enum(['ENTRY', 'ATTRACTION']);

export const BundlePurchaseItemSchema = z.object({
  ticketTypeName: z.string(),
  category: TicketCategorySchema,
  quantity: z.number().int(),
});
export type BundlePurchaseItem = z.infer<typeof BundlePurchaseItemSchema>;

export const BundlePurchaseSchema = z.object({
  id: z.string(),
  bundleCode: z.string(),
  bundleName: z.string(),
  quantity: z.number().int(),
  unitPriceIdr: z.number(),
  totalPriceIdr: z.number(),
  orderNumber: z.string(),
  orderId: z.string(),
  orderStatus: z.string(),
  visitDate: z.string(),
  paymentMethod: z.string(),
  customerId: z.string(),
  ticketCount: z.number().int(),
  items: z.array(BundlePurchaseItemSchema),
  createdAt: z.string(),
});
export type BundlePurchase = z.infer<typeof BundlePurchaseSchema>;

export const BundlePurchasesResponseSchema = z.object({
  purchases: z.array(BundlePurchaseSchema),
  total: z.number().int(),
  page: z.number().int(),
  limit: z.number().int(),
  totalPages: z.number().int(),
});
export type BundlePurchasesResponse = z.infer<typeof BundlePurchasesResponseSchema>;

export const BundlePurchasesQuerySchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(100).optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  search: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});
export type BundlePurchasesQuery = z.infer<typeof BundlePurchasesQuerySchema>;
